const aspectRatio = (props, propName, componentName) => {
	const propGiven = props[propName];
	if (! propGiven) return;
	const testRegex = /^[0-9]+:[0-9]+$/;
	const passed = testRegex.test(propGiven);
	if (! passed) {
		return new Error(
			'Invalid prop `' + propName + '` supplied to' +
					' `' + componentName + '`. Should be a string like 16:9 but instead received ' +
				propGiven + 'which is ' + typeof propGiven
		);
	}
};

export default aspectRatio;
